import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: false,
  contratti: [],
  idContratto: null,
  contrattiSupp: [],
  isDettagliLoading: false,
  contrattoCorrente: null,
};

const contrattiSlice = createSlice({
  name: 'contratti',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaContratti(state, action) {
      state.contratti = action.payload;
    },
    caricamentoContrattiSupp(state, action) {
      state.isDettagliLoading = !!action.payload;
    },
    aggiornaContrattiSupp(state, action) {
      state.contrattiSupp = action.payload;
    },
    selezionaContratto(state, action) {
      state.idContratto = action.payload.idContratto;
      state.contrattoCorrente = action.payload.codiceContratto;
    },
  },
});

export const { caricamento, aggiornaContratti, caricamentoContrattiSupp, aggiornaContrattiSupp, selezionaContratto } = contrattiSlice.actions;
const contrattiReducer = contrattiSlice.reducer;

export default contrattiReducer;
